import React from 'react'
import styled from 'styled-components'
import { ColumnFlexCentered } from '~/components/common/containers'

import { MAX_MOBILE_THRESHOLD } from '~/core/constants'
import { translate } from '~/core/translate'
import { BodyLargeRegular, titleH3Css, titleH4Css } from '../typography'
import Logo from './logo'

const Heading = styled.span`
  ${titleH4Css}
  margin: 32px auto 16px;
`

const Container = styled(ColumnFlexCentered)`
  text-align: center;
  margin: 0 24px 16px;

  ${BodyLargeRegular} {
    color: black;
  }

  @media screen and (min-width: ${MAX_MOBILE_THRESHOLD}) {
    ${Heading} {
      ${titleH3Css}
    }
  }
`

const Title = () => (
  <Container>
    <Logo />
    <Heading>{translate('plans_for_team')}</Heading>
    <BodyLargeRegular>{translate('jaas_heading')}</BodyLargeRegular>
  </Container>
)

export default Title
